import { useEffect, useState } from "react";
import axios from "axios";
import {
    makeStyles
} from "@mui/styles";
import {
    Grid,
    FormControl,
    NativeSelect,
    TextField,
    Button,
    Tabs,
    Tab
} from '@mui/material';
import ClickAwayListener from 'react-click-away-listener';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import CovnersationCard from "../CovnersationCard";

const useStyles = makeStyles({
    header: {
        padding: "10px 15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0px 2px 4px 0px #D1D1D140"
    },
    headerRightSection: {
        display: "flex",
        alignItems: "flex-start"
    },
    selectNumberGrid: {
        position: "relative"
    },
    selectNumberDropdown: {
        cursor: "pointer",
        minWidth: "120px",
        background: 'linear-gradient(180deg,#d92cc1,#4D72F8)',
        color: "white",
        borderRadius: "20px",
        padding: "4px 15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    selectNumberDropdownOptions: {
        backgroundColor: "white",
        boxShadow: "0px 0px 4px 4px #00000014",
        borderRadius: "5px",
        position: "absolute",
        zIndex: 999,
        width: "200px",
        padding: "10px 0px"
    },
    numberOption: {
        padding: "7px 10px",
        cursor: "pointer"
    },
    numberOptionLabel: {
        fontSize: "14px",
        cursor: "pointer",
        width: "100%"
    },
    selectText: {
        margin: 0,
        fontWeight: "bold",
        fontSize: "13px"
    },
    allNumbersBtn: {
        background: 'linear-gradient(180deg,#d92cc1,#4D72F8)',
        border: "none",
        color: "white",
    },
    selectNumber: {
        margin: 0,
        fontSize: 14,
        marginBottom: 5
    },
    chatIcon: {
        height: 25,
        marginRight: 10,
        cursor: "pointer"
    },
    callIcon: {
        height: 20,
        cursor: "pointer"
    },
    bottomSection: {
        backgroundColor: "#EFF1F2",
        padding: "20px",
        paddingTop: "30px",
        paddingBottom: "0px"
    },
    topTabs: {
        "& .MuiTabs-flexContainer": {
            backgroundColor: "white",
            width: "fit-content",
            borderRadius: "25px",
            margin: "auto",
            height: "40px",
            alignItems: "center",
            "& .MuiButtonBase-root": {
                textTransform: "capitalize",
                fontFamily: "CenturyGothic",
                borderRadius: "25px",
                padding: "0px",
            },
            "& .Mui-selected": {
                height: "40px",
                background: "linear-gradient(180deg,#d92cc1,#4D72F8)",
                color: "white",
                fontWeight: "bold",
                minHeight: "40px"
            }
        }
    },
    searchView: {
        marginTop: "10px",
        position: "relative",
        borderRadius: "20px",
        boxShadow: "5px 5px 21px 4px #00000014"
    },
    searchIcon: {
        position: "absolute",
        zIndex: 1,
        left: "10px",
        top: "50%",
        transform: "translate(0%,-50%)",
        color: "#666666"
    },
    search: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: "white",
            borderRadius: "20px",
            '& .MuiInputBase-input': {
                padding: 0,
                paddingLeft: "35px",
                paddingRight: "17px",
                paddingTop: "10px",
                paddingBottom: "10px",
                fontSize: "13px",
                border: "none"
            },
        },
    },
    tabs: {
        display: "flex",
        marginTop: "20px"
    },
    tab: {
        marginRight: "10px !important",
        borderRadius: "20px !important",
        border: "1px solid #d92cc1 !important",
        padding: "3px 18px !important",
        backgroundColor: "white !important",
        color: "#8B8B8B !important",
        fontSize: "14px !important",
        fontWeight: "bold !important",
        textTransform: "capitalize !important"
    },
    activeTab: {
        background: "linear-gradient(180deg,#d92cc1,#4D72F8)",
        color: "white !important"
    },
    tabContent: {
        height: "calc(100vh - 250px)",
        overflowY: "scroll",
        marginLeft: "-20px",
        marginRight: "-20px",
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingTop: "20px",
        paddingBottom: "20px"
    }
});

const LeftSidebar = ({
    outboundNumber,
    onNumberSelected,
    setDialpadIsVisible
}) => {
    const classes = useStyles();
    const [tab, setTab] = useState(0);

    const [eFoneNumbers, setEfoneNumbers] = useState([]);
    const [numbersDropdownIsVisible, setNumbersDropdownIsVisible] = useState(false);

    useEffect(() => {
        fetchOutboundNumbers();
    }, []);

    const fetchOutboundNumbers = () => {
        axios
            .get(process.env.REACT_APP_API_URL + "/" + process.env.REACT_APP_API_VERSION + "/eFoneNumbers/assigned/eFone/numbers", {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("userToken")}`
                }
            })
            .then(response => {
                if (response.data) {
                    console.log("efone numbers", response.data?.data);
                    setEfoneNumbers(response.data?.data);
                }
            })
            .catch(error => {
                console.log("efone numbers error", error);
            });
    }

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };

    const onAllNumbersDropdownBtnClicked = () => {
        setNumbersDropdownIsVisible(!numbersDropdownIsVisible);
    }

    const onOutboundNumberSelected = (number) => {
        setNumbersDropdownIsVisible(false);
        onNumberSelected(number);
    }

    return (
        <>
            <Grid>
                <Grid className={classes.header}>
                    <Grid className={classes.selectNumberGrid}>
                        <p className={classes.selectNumber}>Select your number</p>
                        <div
                            onClick={onAllNumbersDropdownBtnClicked}
                            className={classes.selectNumberDropdown}
                        >
                            <p className={classes.selectText}>
                                {outboundNumber?.phoneNumber || "All Numbers"}
                            </p>
                            <KeyboardArrowDownIcon />
                        </div>
                        {
                            numbersDropdownIsVisible ?
                                <ClickAwayListener onClickAway={() => setNumbersDropdownIsVisible(false)}>
                                    <Grid className={classes.selectNumberDropdownOptions}>
                                        {
                                            eFoneNumbers?.map((number, i) => {
                                                return (
                                                    <Grid
                                                        onClick={() => onOutboundNumberSelected(number)}
                                                        className={classes.numberOption}
                                                    >
                                                        <label className={classes.numberOptionLabel}>
                                                            <input type="radio" value={number.phoneNumber} checked={outboundNumber?.phoneNumber == number.phoneNumber ? true : false} />&nbsp;{number.phoneNumber}
                                                        </label>
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                                </ClickAwayListener>
                                :
                                <></>
                        }
                    </Grid>
                    <Grid className={classes.headerRightSection}>
                        <img
                            src={require("../../assets/icons/chat.png")}
                            className={classes.chatIcon}
                        />
                        <img
                            src={require("../../assets/icons/call.png")}
                            className={classes.callIcon}
                            onClick={() => setDialpadIsVisible(true)}
                        />
                    </Grid>
                </Grid>
                <Grid className={classes.bottomSection}>
                    <Tabs
                        value={tab}
                        onChange={handleTabChange}
                        className={classes.topTabs}
                        TabIndicatorProps={{ style: { display: 'none' } }}
                        centered
                    >
                        <Tab label="Messages" />
                        <Tab label="Calls" />
                    </Tabs>
                    <Grid className={classes.searchView}>
                        <SearchIcon
                            className={classes.searchIcon}
                        />
                        <TextField
                            placeholder="Search"
                            className={classes.search}
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        className={classes.tabs}
                        spacing={2}
                    >
                        <Button
                            className={[classes.tab, classes.activeTab]}
                        >All</Button>
                        <Button
                            className={classes.tab}
                        >Scheduled</Button>
                        <Button
                            className={classes.tab}
                        >Broadcast</Button>
                    </Grid>
                    <Grid
                        className={classes.tabContent}
                    >
                        <CovnersationCard />
                        <CovnersationCard />
                        <CovnersationCard />
                        <CovnersationCard />
                        <CovnersationCard />
                        <CovnersationCard />
                        <CovnersationCard />
                        <CovnersationCard />
                        <CovnersationCard />
                        <CovnersationCard />
                    </Grid>
                </Grid>
            </Grid>

        </>
    )
}

export default LeftSidebar;